import Vue from 'vue'
import moment from 'moment'

Vue.filter('date', date => date !== null ? date.substring(0,10) : ``)
Vue.filter('toDate', date => moment(date).format('YYYY-MM-DD'))
Vue.filter('toDateHourMin', date => moment.unix(date).format('YYYY-MM-DD HH:mm'))
Vue.filter('huf', num => num > 0 ? Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : 0)
Vue.filter('nhuf', num => {
	if(num > 0) {
		return Number(Number(num) / 1.27).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
	} else {
		return 0
	}
	//num > 0 ? Number(num).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : 0
})
Vue.filter('day', date => date !== null ? moment(date).locale('hu').format('dddd') : ``)
Vue.filter('tel', phone => {
	let s = phone
	if(s.length == 10) {
		if((/^361/).test(s)) return s.replace(/(\d{2})(\d{1})(\d{3})(\d{4})/, '$1 $2 $3 $4')
		return s.replace(/(\d{2})(\d{2})(\d{3})(\d{3})/, '$1 $2 $3 $4')
	}
	if(s.length == 11) return s.replace(/(\d{2})(\d{2})(\d{3})(\d{4})/, '$1 $2 $3 $4')
	return phone
})


// WEBPACK FOOTER //
// ./src/filters/index.js